module.exports = __webpack_public_path__ + "img/14.5868bcc4.png";